document.addEventListener('DOMContentLoaded', function () {
    const contactInputs = document.querySelectorAll('.contact-form-input');
    const contactButton = document.querySelector('.contact-form-button');
  
    const checkInputs = () => {
      let allFilled = true;
  
      contactInputs.forEach((field) => {
        if (!field.value) {
          allFilled = false;
        }
      });
  
      if (allFilled) {
        contactButton.removeAttribute('disabled');
      } else {
        contactButton.setAttribute('disabled', 'true');
      }
    };
  
    // Initial check in case the inputs are pre-filled
    checkInputs();
  
    // Add input event listeners to each field
    contactInputs.forEach((field) => {
      field.addEventListener('input', checkInputs);
    });
  });
  